import { signIn } from "next-auth/react";
import router from "next/router";
import LoadingSpinner from "src/Candidate/atoms/LoadingSpinner";
import { useState } from "react";
import Button from "@/admin/atoms/Button";
import Backdrop from "../../Backdrop";
import styles from "./CreateAccountSuccessModal.module.css";

export type ModelType = "create account" | "error" | "contact";

type CreateAccountSuccessModalProps = {
  closeModal: (arg: boolean) => void;
  variant: ModelType;
  userEmail: string;
  userPassword: string;
  companyName?: string;
  packageName?: string;
  cost?: string;
  discount?: number;
  period?: any;
};

function CreateAccountSuccessModal(
  props: CreateAccountSuccessModalProps
): JSX.Element {
  const {
    closeModal,
    variant,
    userEmail = "",
    userPassword = "",
    cost,
    packageName,
    companyName,
    discount = undefined,
    period,
  } = props;

  const [showLoading, setShowLoading] = useState(false);

  const signInUser = () => {
    setShowLoading(true);
    localStorage.setItem("trial-account-login", "1");
    signIn("credentials", {
      email: userEmail,
      password: userPassword,
      redirect: false,
    }).then((res) => {
      router.replace("/admin-portal/course-library/all-courses");
      console.log(res, companyName);
    });
  };

  return (
    <Backdrop>
      <div className={styles.frame}>
        <div className="w-full flex justify-end p-2">
          {variant !== "contact" && (
            <div
              className=" w-6 h-6 cursor-pointer "
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              onClick={() => {
                if (variant === "create account") {
                  signInUser();
                } else {
                  closeModal(false);
                }
              }}
            >
              <img src="/icons/close-circle.svg" alt="close button" />
            </div>
          )}
        </div>

        <div className="w-full flex justify-center mt-4">
          {variant === "create account" ? (
            <img
              src="/icons/tick-square.svg"
              className="phone:w-[64px] phone:h-[64px]"
              alt="tick circle"
            />
          ) : variant === "contact" ? (
            <img
              src="/icons/tick-square.svg"
              className="phone:w-[64px] phone:h-[64px]"
              alt="tcik sqaure"
            />
          ) : (
            <img src="/icons/info-circle2.svg" alt="infor" />
          )}
        </div>
        <div
          className={`w-full mt-6 phone:px-5 phone:text-[20px] text-center flex justify-center font-bold text-[30px] leading-[150%] 
                    ${
                      variant === "create account" || variant === "contact"
                        ? "text-[#05AA4B]"
                        : "text-[#FF2728]"
                    }`}
        >
          {variant === "create account"
            ? "Subscription Confirmed"
            : variant === "contact"
            ? "Thank You for Reaching Out!"
            : "Something Went Wrong!"}
        </div>

        <div className="w-full flex justify-center mt-2">
          <div className="w-[70%] phone:w-[90%] text-center leading-[150%] text-[16px]">
            {variant === "create account"
              ? `${
                  discount ? `Thanks for using your ${discount}% coupon!` : ""
                } Your subscription has been activated`
              : variant === "contact"
              ? "We've received your request and our support team will get in touch with you shortly."
              : "Oops! There was a problem verifying your email. Please check your connection and try again."}
          </div>
        </div>
        {variant !== "contact" ? (
          <div className="px-24 phone:px-4 py-4">
            <div className="w-full space-y-4 p-4 rounded-lg bg-[rgba(237,238,252,0.32)]">
              <div className="flex justify-between">
                <div className="text-black600 text-base">Payment For:</div>
                <div className="text-black800 text-base font-bold">
                  {packageName} - {period}
                </div>
              </div>
              <div className="flex justify-between">
                <div className="text-black600 text-base">Amount Paid:</div>
                {discount ? (
                  <div className="text-blue500 text-base font-bold">
                    £{Number(cost) - (discount / 100) * Number(cost)}
                  </div>
                ) : (
                  <div className="text-blue500 text-base font-bold">
                    £{cost}
                  </div>
                )}
              </div>
              <div className="flex justify-between">
                <div className="text-black600 text-base">Discount Applied:</div>
                <div className="text-green500 text-base font-bold">{`${
                  discount ?? 0
                }% off`}</div>
              </div>
              <div className="flex justify-between">
                <div className="text-black600 text-base">Auto Renewal:</div>
                {discount ? (
                  <div className="text-blue500 text-base font-bold">
                    {discount < 100 ? "Yes" : "No"}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}

        <div className="w-full pl-[5%] mt-6 text-[#555555] phone:pl-8">
          <div className=" font-medium w-full">
            {variant === "contact" ? "While you wait..." : ""}
          </div>

          {variant === "create account" ? (
            <ul className="text-[16px] phone:text-[12px]">
              {/*
              <li>Explore your dashbaord</li>
              <li>Create and Manage users, courses, events and videos</li>
              */}
            </ul>
          ) : variant === "contact" ? (
            <ul className="text-[16px] phone:text-[12px]">
              <li>
                Feel free to explore our Knowledge Base and FAQs for quick
                answers.
              </li>
              <li>Need Urgent help? [Contact Support]</li>
            </ul>
          ) : (
            <ul className="text-[16px]">
              <li>Contact Support via [Support link]</li>
              <li>Click on the retry button below</li>
            </ul>
          )}
        </div>

        <div className="w-full flex justify-center mt-10">
          <div className="w-[50%] phone:w-[80%]">
            {variant === "create account" || variant === "contact" ? (
              <Button
                variant="landing-primary2"
                onClick={() => {
                  if (variant === "create account") {
                    signInUser();
                  } else if (variant === "contact") {
                    router.replace("/");
                  }
                }}
              >
                <p className="w-full py-6">
                  {variant === "create account"
                    ? "Continue to Dashboard"
                    : "Continue to Homepage"}
                </p>
              </Button>
            ) : (
              <Button variant="secondaryRed500">
                <p className="py-1 px-4 phone:w-full phone:text-center">
                  Retry
                </p>
              </Button>
            )}
          </div>
        </div>
        <div className="w-full flex justify-center mt-8 phone:px-4">
          <div className="w-[90%] border border-dashed border-[#979797]" />
        </div>
        {variant === "create account" ? (
          <div className="w-full py-8 text-center text-black600 text-sm">
            A confirmation email has been sent to your registered email address
          </div>
        ) : (
          ""
        )}
        {showLoading ? <LoadingSpinner /> : null}
      </div>
    </Backdrop>
  );
}

export default CreateAccountSuccessModal;
